export default __webpack_public_path__ + "static/logo-kien-truc-tuyet-my-02-829f1506db7677b98e7c9b6d139d98c5.png";